import React, { useState } from 'react'
import CloseButton from '../shared/CloseButton'
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'reactstrap'

import axios from '../shared/axios'

export default function RenameModal(props) {
  const { graphic, isOpen, close, setGraphic, renameLink } = props
  const [newTitle, setNewTitle] = useState(graphic ? graphic.attributes.title : '')
  const [processing, setProcessing] = useState(false)

  const setFocus = () => {
    const input = document.querySelector('#graphic-title')
    input.focus()
    input.select()
  }


  const handleRename = async (e) => {
    e.preventDefault()
    setProcessing(true)
    const formData = new FormData(e.target)
    const response = await axios.post(renameLink, formData)
    setGraphic(response.data.data)
    setProcessing(false)
    close()
  }

  return (
    <Modal isOpen={isOpen} toggle={close} size="sm" onOpened={setFocus}>
      <ModalHeader toggle={close} close={<CloseButton onClick={close} />} tag="h3">
        Rename Graphic
      </ModalHeader>
      <Form onSubmit={handleRename}>
        <ModalBody>
          <FormGroup>
            <Label for="upload-filename">Graphic Name</Label>
            <Input
              type="text"
              id="graphic-title"
              name="graphic[display_title]"
              placeholder="Default title"
              onChange={(e) => setNewTitle(e.target.value)}
              value={newTitle} />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" type="submit" disabled={processing}>
            Save
          </Button>
          <Button color="outline-secondary" onClick={close}>
            Cancel
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  )
}
